import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useCommissionRecalculationTaskFilterFields } from './hooks/useCommissionRecalculationTaskFilterFields';

export const CommissionRecalculationTaskListFilter: React.FC = () => {
  const fields = useCommissionRecalculationTaskFilterFields();

  return <FilterFields fields={fields} />;
};
